import { render, staticRenderFns } from "./WidgetTotalScore.vue?vue&type=template&id=7e0d7842&"
import script from "./WidgetTotalScore.vue?vue&type=script&lang=js&"
export * from "./WidgetTotalScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports